// Utilizar det en test walmericTest=cookie
// if (window.location.href.indexOf("walmericTest=cookie") > -1) {
sessionStorage.setItem("debugDET", "on");

// }

if (typeof DFI_client === "undefined") {
  DFI_client = {};
}

//Telefonos por defecto adeslas
globalThis.DFI_client.defaultPhone = "919018239";
globalThis.DFI_client.defaultPhoneUnailable = "919018239";

// MapeoDataLayer

if (window.location.href.indexOf("wm_env=d") > -1) {
  var script = document.createElement("script");
  script.type = "text/javascript";
  script.src =
    "https://t.womtp.com/slider/d/segurcaixaadeslas/satellite/mainSatellite.js";
  var head = document.getElementsByTagName("head")[0];
  head.appendChild(script);
} else if (window.location.pathname === "/es/particulares/Clientes") {
  // do nothing
} else {
  // Visita 7 idioma

  // Remove Emergia

  // if(window.location.href.indexOf("walmericTest=true") > 0
  // && document.getElementsByClassName("sc-fly__container").length > 0 ){
  // document.getElementsByClassName("sc-fly__container")[0].style.display ="none";
  // }

  const isEmergia = function () {
    const urls = [
      "segurcaixaadeslas.es/es/seguros-medicos/adeslas-completa",
      "segurcaixaadeslas.es/es/seguros-medicos/adeslas-basico-familia",
      "segurcaixaadeslas.es/es/seguros-medicos/adeslas-seniors",
      "segurcaixaadeslas.es/es/seguros-medicos/adeslas-extra-150mil",
      "segurcaixaadeslas.es/es/seguros-medicos/adeslas-extra-240mil",
      "segurcaixaadeslas.es/es/seguros-medicos/adeslas-premier",
      "segurcaixaadeslas.es/es/seguros-medicos/adeslas-dental-familia",
      "segurcaixaadeslas.es/es/seguros-autonomos-y-pymes/seguros-medico/adeslas-negocios",
      "segurcaixaadeslas.es/es/seguros-autonomos-y-pymes/seguros-medico/adeslas-empresas",
      "segurcaixaadeslas.es/es/seguros-autonomos-y-pymes/seguros-medico/adeslas-negocios-y-dental",
      "segurcaixaadeslas.es/es/seguros-autonomos-y-pymes/seguros-medico/adeslas-empresas-y-dental",
      "segurcaixaadeslas.es/es/seguros-autonomos-y-pymes/seguros-medico/adeslas-extra-negocios",
      "segurcaixaadeslas.es/es/seguros-autonomos-y-pymes/seguros-medico/adeslas-extra-empresas",
      "segurcaixaadeslas.es/es/seguros-autonomos-y-pymes/seguros-medico/adeslas-extra-negocios-y-dental",
      "segurcaixaadeslas.es/es/seguros-autonomos-y-pymes/seguros-medico/adeslas-extra-empresas-y-dental",
      "segurcaixaadeslas.es/es/seguros-autonomos-y-pymes/seguros-medico/adeslas-dental-autonomos",
      "segurcaixaadeslas.es/es/seguros-autonomos-y-pymes/seguros-medico/adeslas-dental-negocios-y-empresas",
      "segurcaixaadeslas.es/es/seguros-autonomos-y-pymes/seguros-medico/plus-adeslas-clinica-universitaria-de-navarra",
      "segurcaixaadeslas.es/es/seguros-autonomos-y-pymes/seguros-medico/plus-adeslas-prestacion-economica-por-incapacidad-temporal",
      "segurcaixaadeslas.es/es/seguros-autonomos-y-pymes/seguros-medico/plus-adeslas-ginecologia-y-pediatria",
      "segurcaixaadeslas.es/es/seguros-autonomos-y-pymes/seguros-de-accidentes",
      "segurcaixaadeslas.es/es/particulares-sitio/seguros-de-accidentes-sitio",
      "segurcaixaadeslas.es/es/seguros-de-decesos",
      "segurcaixaadeslas.es/es/seguros-de-hogar",
      "segurcaixaadeslas.es/es/seguros-de-hogar",
      "segurcaixaadeslas.es/es/seguros-de-hogar/segurcaixa-hogar",
      "segurcaixaadeslas.es/es/seguros-de-hogar/segurcaixa-hogar-completo",
      "segurcaixaadeslas.es/es/seguros-de-coches",
      "segurcaixaadeslas.es/es/seguros-de-coches/terceros",
      "segurcaixaadeslas.es/es/seguros-de-coches/terceros-con-lunas",
      "segurcaixaadeslas.es/es/seguros-de-coches/terceros-ampliado",
      "segurcaixaadeslas.es/es/seguros-de-coches/todo-riesgo",
      "segurcaixaadeslas.es/es/seguro-de-electrodomesticos",
      "segurcaixaadeslas.es/es/seguro-de-mascotas",
      "segurcaixaadeslas.es/es/seguros-autonomos-y-pymes/seguros-medico/adeslas-extra-negocios",
      "segurcaixaadeslas.es/es/seguro-de-proteccion-juridica-particulares",
      "segurcaixaadeslas.es/es/seguros-autonomos-y-pymes/seguros-de-coches",
      "segurcaixaadeslas.es/es/seguros-autonomos-y-pymes/seguros-de-coches/terceros",
      "segurcaixaadeslas.es/es/seguros-autonomos-y-pymes/seguros-de-coches/terceros-con-lunas",
      "segurcaixaadeslas.es/es/seguros-autonomos-y-pymes/seguros-de-coches/terceros-ampliado",
      "segurcaixaadeslas.es/es/seguros-autonomos-y-pymes/seguros-de-coches/todo-riesgo",
      "segurcaixaadeslas.es/es/seguros-medicos/adeslas-go",
      "segurcaixaadeslas.es/ca/seguros-medicos/adeslas-go",
      "segurcaixaadeslas.es/es/seguros-medicos/adeslas-dental-max",
      "segurcaixaadeslas.es/ca/seguros-medicos/adeslas-dental-max",
    ];

    let urlFound = false;

    urls.forEach(function (url, i) {
      if (~location.href.indexOf(url)) {
        urlFound = true;
      }
    });
    // si pertenece a una de estas url
    return urlFound;
  };

  // Interferir botones para levantar nuestra modal en pestañas:
  // https://www.segurcaixaadeslas.es/es/seguros-medicos/adeslas-completa

  const emergia = isEmergia();
  const btnsEmergia = document.querySelectorAll(
    ".vertical-tab-menu.salud .btn.phone.mt20"
  );
  const btnsDecesos = document.querySelectorAll("a.SCALinkModal");
  const btnssegurosMedicos = document.querySelectorAll("a.btn.phone.mt20");

  if (emergia && btnsEmergia.length > 0) {
    btnsEmergia.forEach(function (e) {
      e.removeAttribute("href");
      e.removeAttribute("onclick");
      e.classList.add("dModalForm");
    });
  } else if (emergia && btnsDecesos.length > 0) {
    btnsDecesos.forEach(function (e) {
      e.removeAttribute("href");
      e.removeAttribute("onclick");
      e.classList.add("dModalForm");
    });
  } else if (
    (emergia ||
      window.location.href.indexOf(
        "segurcaixaadeslas.es/es/mutualistas/seguros-medico"
      ) > -1) &&
    btnssegurosMedicos.length > 0
  ) {
    btnssegurosMedicos.forEach(function (e) {
      e.removeAttribute("href");
      e.removeAttribute("onclick");
      e.classList.add("dModalForm");
    });
  }

  const botonDeAdeslas = document.getElementsByClassName("sc-fly__container");
  var dsaInterval = setInterval(function () {
    if (
      window.DFI &&
      window.DFI.resultShowRules &&
      window.DFI.resultShowRules.actionIsOkDSA &&
      window.DFI.resultShowRules.actionIsOkDSA === "show"
    ) {
      clearInterval(dsaInterval);
      if (botonDeAdeslas.length > 0) {
        botonDeAdeslas[0].style.display = "none";
      }
    }
  }, 100);

  if (typeof dataLayerAdeslas !== "object") {
    dataLayerAdeslas = {};

    dataLayerAdeslas.htmlLang = document.documentElement.lang;

    if (document.documentElement.lang === "es") {
      if (
        document.querySelectorAll(".link-idioma.active").length > 0 &&
        document.querySelectorAll(".link-idioma.active")[0].innerText === "CAT"
      ) {
        dataLayerAdeslas.htmlLang = "ca-ES";
      } else {
        dataLayerAdeslas.htmlLang = "es-ES";
      }
    }
  }

  if (
    getUrlVarSegurcaixa("fbclid") != "" &&
    getUrlVarSegurcaixa("fbclid").length > 5
  ) {
    dataLayerAdeslas.fbclid = getUrlVarSegurcaixa("fbclid");
  }

  const lang = document.documentElement.lang;
  if (window.location.host.indexOf("seguros.adeslas") > -1) {
    if (document.getElementsByClassName("drp-phone").length > 0) {
      for (
        let indice = 0,
          len = document.getElementsByClassName("drp-phone").length;
        indice < len;
        indice++
      ) {
        document.getElementsByClassName("drp-phone")[indice].className +=
          " html-drp-phone";
      }
    }

    if (typeof dataLayer === "object") {
      if (typeof dataLayer[0] === "object") {
        if (typeof dataLayer[0].Seccion !== "undefined") {
          dataLayerAdeslas.Seccion = dataLayer[0].Seccion;
        }

        if (typeof dataLayer[0].Idioma !== "undefined") {
          dataLayerAdeslas.Idioma = dataLayer[0].Idioma;
        }

        if (typeof dataLayer[0].TipoProducto !== "undefined") {
          dataLayerAdeslas.TipoProducto = dataLayer[0].TipoProducto;
        }

        if (typeof dataLayer[0].TipoCliente !== "undefined") {
          dataLayerAdeslas.TipoCliente = dataLayer[0].TipoCliente;
        }

        if (typeof dataLayer[0].Localizacion !== "undefined") {
          dataLayerAdeslas.Localizacion = dataLayer[0].Localizacion;
        }

        if (typeof dataLayer[0].Pagina !== "undefined") {
          dataLayerAdeslas.Pagina = dataLayer[0].Pagina;
        }

        if (typeof dataLayer[0].Paso !== "undefined") {
          dataLayerAdeslas.Paso = dataLayer[0].Paso;
        }
      }

      if (typeof dataLayer[2] === "object") {
        if (typeof dataLayer[2].event !== "undefined") {
          dataLayerAdeslas.event = dataLayer[2].event;
        } else if (typeof dataLayer[3].event !== "undefined") {
          dataLayerAdeslas.event = dataLayer[3].event;
        }

        if (typeof dataLayer[2].Idioma !== "undefined") {
          dataLayerAdeslas.Idioma = dataLayer[2].Idioma;
        } else if (
          typeof dataLayer[3] !== "undefined" &&
          typeof dataLayer[3].Idioma !== "undefined"
        ) {
          dataLayerAdeslas.Idioma = dataLayer[3].Idioma;
        }

        if (typeof dataLayer[2].TipoProducto !== "undefined") {
          dataLayerAdeslas.TipoProducto = dataLayer[2].TipoProducto;
        } else if (
          typeof dataLayer[3] !== "undefined" &&
          typeof dataLayer[3].TipoProducto !== "undefined"
        ) {
          dataLayerAdeslas.TipoProducto = dataLayer[3].TipoProducto;
        }

        if (typeof dataLayer[2].Origen !== "undefined") {
          dataLayerAdeslas.Origen = dataLayer[2].Origen;
        } else if (
          typeof dataLayer[3] !== "undefined" &&
          typeof dataLayer[3].Origen !== "undefined"
        ) {
          dataLayerAdeslas.Origen = dataLayer[3].Origen;
        }

        if (typeof dataLayer[2].Device !== "undefined") {
          dataLayerAdeslas.Device = dataLayer[2].Device;
        } else if (
          typeof dataLayer[3] !== "undefined" &&
          typeof dataLayer[3].Device !== "undefined"
        ) {
          dataLayerAdeslas.Device = dataLayer[3].Device;
        }

        if (typeof dataLayer[2].Paso !== "undefined") {
          dataLayerAdeslas.Paso = dataLayer[2].Paso;
        } else if (
          typeof dataLayer[3] !== "undefined" &&
          typeof dataLayer[3].Paso !== "undefined"
        ) {
          dataLayerAdeslas.Paso = dataLayer[3].Paso;
        }

        if (typeof dataLayer[2].NAsegurados !== "undefined") {
          dataLayerAdeslas.NAsegurados = dataLayer[2].NAsegurados;
        } else if (
          typeof dataLayer[3] !== "undefined" &&
          typeof dataLayer[3].NAsegurados !== "undefined"
        ) {
          dataLayerAdeslas.NAsegurados = dataLayer[3].NAsegurados;
        }

        if (typeof dataLayer[2].Precio !== "undefined") {
          dataLayerAdeslas.Precio = dataLayer[2].Precio;
        } else if (
          typeof dataLayer[3] !== "undefined" &&
          typeof dataLayer[3].Precio !== "undefined"
        ) {
          dataLayerAdeslas.Precio = dataLayer[3].Precio;
        }

        if (typeof dataLayer[2].PrecioDental !== "undefined") {
          dataLayerAdeslas.PrecioDental = dataLayer[2].PrecioDental;
        } else if (
          typeof dataLayer[3] !== "undefined" &&
          typeof dataLayer[3].PrecioDental !== "undefined"
        ) {
          dataLayerAdeslas.PrecioDental = dataLayer[3].PrecioDental;
        }

        if (typeof dataLayer[2].gclid !== "undefined") {
          dataLayerAdeslas.gclid = dataLayer[2].gclid;
        } else if (
          typeof dataLayer[3] !== "undefined" &&
          typeof dataLayer[3].gclid !== "undefined"
        ) {
          dataLayerAdeslas.gclid = dataLayer[3].gclid;
        }

        if (typeof dataLayer[2].MsclkId !== "undefined") {
          dataLayerAdeslas.MsclkId = dataLayer[2].MsclkId;
        } else if (
          typeof dataLayer[3] !== "undefined" &&
          typeof dataLayer[3].MsclkId !== "undefined"
        ) {
          dataLayerAdeslas.MsclkId = dataLayer[3].MsclkId;
        }

        if (typeof dataLayer[2].Keyword !== "undefined") {
          dataLayerAdeslas.Keyword = dataLayer[2].Keyword;
        } else if (
          typeof dataLayer[3] !== "undefined" &&
          typeof dataLayer[3].Keyword !== "undefined"
        ) {
          dataLayerAdeslas.Keyword = dataLayer[3].Keyword;
        }

        if (typeof dataLayer[2].MatchType !== "undefined") {
          dataLayerAdeslas.MatchType = dataLayer[2].MatchType;
        } else if (
          typeof dataLayer[3] !== "undefined" &&
          typeof dataLayer[3].MatchType !== "undefined"
        ) {
          dataLayerAdeslas.MatchType = dataLayer[3].MatchType;
        }

        if (typeof dataLayer[2].CampaingId !== "undefined") {
          dataLayerAdeslas.CampaingId = dataLayer[2].CampaingId;
        } else if (
          typeof dataLayer[3] !== "undefined" &&
          typeof dataLayer[3].CampaingId !== "undefined"
        ) {
          dataLayerAdeslas.CampaingId = dataLayer[3].CampaingId;
        }

        if (typeof dataLayer[2].MatchType !== "undefined") {
          dataLayerAdeslas.MatchType = dataLayer[2].MatchType;
        } else if (
          typeof dataLayer[3] !== "undefined" &&
          typeof dataLayer[3].MatchType !== "undefined"
        ) {
          dataLayerAdeslas.MatchType = dataLayer[3].MatchType;
        }

        if (typeof dataLayer[2].AdgroupId !== "undefined") {
          dataLayerAdeslas.AdgroupId = dataLayer[2].AdgroupId;
        } else if (
          typeof dataLayer[3] !== "undefined" &&
          typeof dataLayer[3].AdgroupId !== "undefined"
        ) {
          dataLayerAdeslas.AdgroupId = dataLayer[3].AdgroupId;
        }

        if (typeof dataLayer[2].Formato !== "undefined") {
          dataLayerAdeslas.Formato = dataLayer[2].Formato;
        } else if (
          typeof dataLayer[3] !== "undefined" &&
          typeof dataLayer[3].Formato !== "undefined"
        ) {
          dataLayerAdeslas.Formato = dataLayer[3].Formato;
        }

        if (typeof dataLayer[2].Creative !== "undefined") {
          dataLayerAdeslas.Creative = dataLayer[2].Creative;
        } else if (
          typeof dataLayer[3] !== "undefined" &&
          typeof dataLayer[3].Creative !== "undefined"
        ) {
          dataLayerAdeslas.Creative = dataLayer[3].Creative;
        }
      }
    }
  }

  // add url conversion
  if (dataLayerAdeslas.urlConversion == "undefined") {
    dataLayerAdeslas.urlConversion = window.location.href;
  }

  // Check mobile or desktop device
  function mobileAndTabletcheck() {
    let check = false;
    (function (a) {
      if (
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
          a
        ) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
          a.substr(0, 4)
        )
      ) {
        check = true;
      }
    })(navigator.userAgent || navigator.vendor || window.opera);

    if (window.matchMedia("(orientation: portrait)").matches) {
      if (screen.width > 767) {
        check = false;
      }
    }

    if (window.matchMedia("(orientation: landscape)").matches) {
      if (screen.height > 767) {
        check = false;
      }
    }

    return check;
  }

  if (mobileAndTabletcheck()) {
    dataLayerAdeslas.Device = "mobile";
  } else {
    dataLayerAdeslas.Device = "desktop";
  }

  //Funcion para obener el valor de un param
  function getParamUrl(nombreParametro) {
    const url = globalThis.location.href;
    const urlObj = new URL(url);

    const valor = urlObj.searchParams.get(nombreParametro);

    // Si no se encuentra, devuelve una cadena vacía
    return valor !== null ? valor : "";
  }

  dataLayerAdeslas.vc = getParamUrl("VC");
  dataLayerAdeslas.Origen = getParamUrl("origen");

  // create object.
  const objectDatalayerAdeslas = [
    {
      seccion_web: "pymes_y_autonomos",
      tipo_seguro: "seguros_medicos",
      categoria_seguro: "plus_adeslas_clinica_universitaria_de_navarra",
      url: "https://www.segurcaixaadeslas.es/es/seguros-autonomos-y-pymes/seguros-medico/plus-adeslas-clinica-universitaria-de-navarra",
    },
    {
      seccion_web: "pymes_y_autonomos",
      tipo_seguro: "seguros_medicos",
      categoria_seguro: "plus_adeslas_incapacidad_temporal",
      url: "https://www.segurcaixaadeslas.es/es/seguros-autonomos-y-pymes/seguros-medico/plus-adeslas-prestacion-economica-por-incapacidad-temporal",
    },
    {
      seccion_web: "pymes_y_autonomos",
      tipo_seguro: "seguros_medicos",
      categoria_seguro: "plus_adeslas_ginecologia_pediatria",
      url: "https://www.segurcaixaadeslas.es/es/seguros-autonomos-y-pymes/seguros-medico/plus-adeslas-ginecologia-y-pediatria",
    },
    {
      seccion_web: "pymes_y_autonomos",
      tipo_seguro: "seguros_medicos",
      categoria_seguro: "adeslas_dental_negocios_y_empresas",
      url: "https://www.segurcaixaadeslas.es/es/seguros-autonomos-y-pymes/seguros-medico/adeslas-dental-negocios-y-empresas",
    },
    {
      seccion_web: "pymes_y_autonomos",
      tipo_seguro: "seguros_medicos",
      categoria_seguro: "adeslas_extra_negocios_y_dental",
      url: "https://www.segurcaixaadeslas.es/es/seguros-autonomos-y-pymes/seguros-medico/adeslas-extra-negocios-y-dental",
    },
    {
      seccion_web: "pymes_y_autonomos",
      tipo_seguro: "seguros_medicos",
      categoria_seguro: "adeslas_extra_empresas_y_dental",
      url: "https://www.segurcaixaadeslas.es/es/seguros-autonomos-y-pymes/seguros-medico/adeslas-extra-empresas-y-dental",
    },
    {
      seccion_web: "pymes_y_autonomos",
      tipo_seguro: "seguros_medicos",
      categoria_seguro: "adeslas_negocios_y_dental",
      url: "https://www.segurcaixaadeslas.es/es/seguros-autonomos-y-pymes/seguros-medico/adeslas-negocios-y-dental",
    },
    {
      seccion_web: "pymes_y_autonomos",
      tipo_seguro: "seguros_medicos",
      categoria_seguro: "adeslas_empresas_y_dental",
      url: "https://www.segurcaixaadeslas.es/es/seguros-autonomos-y-pymes/seguros-medico/adeslas-empresas-y-dental",
    },
    {
      seccion_web: "empresas",
      tipo_seguro: "seguros_medicos",
      categoria_seguro: "adeslas_extra_empresas_y_Dental",
      url: "https://www.segurcaixaadeslas.es/es/seguros-para-empresas/seguro-de-salud/adeslas-extra-empresas-y-dental",
    },
    {
      seccion_web: "pymes_y_autonomos",
      tipo_seguro: "seguros_medicos",
      categoria_seguro: "adeslas_dental_autonomos",
      url: "https://www.segurcaixaadeslas.es/es/seguros-autonomos-y-pymes/seguros-medico/adeslas-dental-autonomos",
    },
    {
      seccion_web: "pymes_y_autonomos",
      tipo_seguro: "seguros_medicos",
      categoria_seguro: "adeslas_extra_negocios",
      url: "https://www.segurcaixaadeslas.es/es/seguros-autonomos-y-pymes/seguros-medico/adeslas-extra-negocios",
    },
    {
      seccion_web: "pymes_y_autonomos",
      tipo_seguro: "seguros_medicos",
      categoria_seguro: "adeslas_extra_empresas",
      url: "https://www.segurcaixaadeslas.es/es/seguros-autonomos-y-pymes/seguros-medico/adeslas-extra-empresas",
    },
    {
      seccion_web: "pymes_y_autonomos",
      tipo_seguro: "seguros_dentale",
      categoria_seguro: "",
      url: "https://www.segurcaixaadeslas.es/es/seguros-autonomos-y-pymes-sitio/seguro-dental-sitio/Paginas/seguros-dentales.aspx",
    },
    {
      seccion_web: "empresas",
      tipo_seguro: "seguros_medicos",
      categoria_seguro: "adeslas_empresas_y_dental",
      url: "https://www.segurcaixaadeslas.es/es/seguros-para-empresas/seguro-de-salud/adeslas-empresas-y-dental",
    },
    {
      seccion_web: "pymes_y_autonomos",
      tipo_seguro: "seguros_medicos",
      categoria_seguro: "adeslas_negocios",
      url: "https://www.segurcaixaadeslas.es/es/seguros-autonomos-y-pymes/seguros-medico/adeslas-negocios",
    },
    {
      seccion_web: "pymes_y_autonomos",
      tipo_seguro: "seguros_medicos",
      categoria_seguro: "adeslas_empresas",
      url: "https://www.segurcaixaadeslas.es/es/seguros-autonomos-y-pymes/seguros-medico/adeslas-empresas",
    },
    {
      seccion_web: "empresas",
      tipo_seguro: "seguros_medicos",
      categoria_seguro: "adeslas_extra_empresas",
      url: "https://www.segurcaixaadeslas.es/es/seguros-para-empresas/seguro-de-salud/adeslas-extra-empresas",
    },
    {
      seccion_web: "empresas",
      tipo_seguro: "seguros_medicos",
      categoria_seguro: "adeslas_empresas",
      url: "https://www.segurcaixaadeslas.es/es/seguros-para-empresas/seguro-de-salud/adeslas-empresas",
    },
    {
      seccion_web: "empresas",
      tipo_seguro: "seguros_medicos",
      categoria_seguro: "adeslas_primera",
      url: "https://www.segurcaixaadeslas.es/es/seguros-para-empresas/seguro-de-salud/adeslas-primera",
    },
    {
      seccion_web: "pymes_y_autonomos",
      tipo_seguro: "seguros_accidentes",
      categoria_seguro: "",
      url: "https://www.segurcaixaadeslas.es/es/seguros-autonomos-y-pymes/seguros-de-accidentes",
    },
    {
      seccion_web: "pymes_y_autonomos",
      tipo_seguro: "segurcaixa_negocio",
      categoria_seguro: "",
      url: "https://www.segurcaixaadeslas.es/es/seguros-autonomos-y-pymes/seguro-caixa-negocio",
    },
    {
      seccion_web: "pymes_y_autonomos",
      tipo_seguro: "seguros_coche",
      categoria_seguro: "",
      url: "https://www.segurcaixaadeslas.es/es/seguros-autonomos-y-pymes/seguros-de-coches",
    },
    {
      seccion_web: "pymes_y_autonomos",
      tipo_seguro: "seguros_medicos",
      categoria_seguro: "",
      url: "https://www.segurcaixaadeslas.es/es/seguros-autonomos-y-pymes/seguros-medico",
    },
    {
      seccion_web: "particulares",
      tipo_seguro: "otros_seguros",
      categoria_seguro: "",
      url: "https://www.segurcaixaadeslas.es/es/particulares-sitio/seguros-de-accidentes-sitio",
    },
    {
      seccion_web: "particulares",
      tipo_seguro: "seguros_jurídica",
      categoria_seguro: "",
      url: "https://www.segurcaixaadeslas.es/es/seguro-de-proteccion-juridica-particulares",
    },
    {
      seccion_web: "empresas",
      tipo_seguro: "seguros_multiriesgo",
      categoria_seguro: "",
      url: "https://www.segurcaixaadeslas.es/es/seguros-para-empresas/seguros-multirriesgo",
    },
    {
      seccion_web: "empresas",
      tipo_seguro: "rc_directivos",
      categoria_seguro: "",
      url: "https://www.segurcaixaadeslas.es/es/seguros-para-empresas/seguro-rcdirectivos",
    },
    {
      seccion_web: "empresas",
      tipo_seguro: "seguros_medicos",
      categoria_seguro: "",
      url: "https://www.segurcaixaadeslas.es/es/seguros-para-empresas/seguro-de-salud",
    },
    {
      seccion_web: "particulares",
      tipo_seguro: "seguros_electrodomésticos",
      categoria_seguro: "",
      url: "https://www.segurcaixaadeslas.es/es/seguro-de-electrodomesticos",
    },
    {
      seccion_web: "particulares",
      tipo_seguro: "seguros_mascotas",
      categoria_seguro: "",
      url: "https://www.segurcaixaadeslas.es/es/seguro-de-mascotas",
    },
    {
      seccion_web: "empresas",
      tipo_seguro: "seguros_rc",
      categoria_seguro: "",
      url: "https://www.segurcaixaadeslas.es/es/seguros-para-empresas/seguro-respcivil",
    },
    {
      seccion_web: "mutualistas",
      tipo_seguro: "Elige_adeslas",
      categoria_seguro: "",
      url: "https://www.segurcaixaadeslas.es/es/mutualistas/ven-a-adeslas",
    },
    {
      seccion_web: "empresas",
      tipo_seguro: "seguros_arte",
      categoria_seguro: "",
      url: "https://www.segurcaixaadeslas.es/es/seguros-para-empresas/arte",
    },
    {
      seccion_web: "particulares",
      tipo_seguro: "seguros_decesos",
      categoria_seguro: "",
      url: "https://www.segurcaixaadeslas.es/es/seguros-de-decesos",
    },
    {
      seccion_web: "particulares",
      tipo_seguro: "seguros_dentales",
      categoria_seguro: "",
      yaCliente: "cliente",
      url: "https://www.segurcaixaadeslas.es/es/seguros-dentales",
    },
    {
      seccion_web: "particulares",
      tipo_seguro: "seguros_medicos",
      categoria_seguro: "",
      url: "https://www.segurcaixaadeslas.es/es/seguros-medicos",
    },
    {
      seccion_web: "particulares",
      tipo_seguro: "seguros_coche",
      categoria_seguro: "",
      url: "https://www.segurcaixaadeslas.es/es/seguros-de-coches",
    },
    {
      seccion_web: "particulares",
      tipo_seguro: "seguros_hogar",
      categoria_seguro: "",
      url: "https://www.segurcaixaadeslas.es/es/seguros-de-hogar",
    },
    {
      seccion_web: "particulares",
      tipo_seguro: "seguros_seguros",
      categoria_seguro: "",
      url: "https://www.segurcaixaadeslas.es/es/otros-seguros",
    },
    {
      seccion_web: "mutualistas",
      tipo_seguro: "Mugeju",
      categoria_seguro: "",
      url: "https://www.segurcaixaadeslas.es/es/mutualistas/mugeju",
    },
    {
      seccion_web: "mutualistas",
      tipo_seguro: "Muface",
      categoria_seguro: "",
      url: "https://www.segurcaixaadeslas.es/es/mutualistas/muface",
    },
    {
      seccion_web: "mutualistas",
      tipo_seguro: "Isfas",
      categoria_seguro: "",
      url: "https://www.segurcaixaadeslas.es/es/mutualistas/isfas",
    },
    {
      seccion_web: "empresas",
      tipo_seguro: "",
      categoria_seguro: "",
      url: "https://www.segurcaixaadeslas.es/es/seguros-para-empresas",
    },
    {
      seccion_web: "Home",
      tipo_seguro: "",
      categoria_seguro: "",
      url: "https://www.segurcaixaadeslas.es/es/particulares",
    },
    {
      seccion_web: "mutualistas",
      tipo_seguro: "",
      categoria_seguro: "",
      url: "https://www.segurcaixaadeslas.es/es/mutualistas",
    },
    {
      seccion_web: "Particulares",
      tipo_seguro: "otros seguros",
      categoria_seguro: "seguros mascotas",
      url: "https://www.segurcaixaadeslas.es/es/landing-sitio/Paginas/seguros-mascotas.html",
    },
  ];

  for (const el of objectDatalayerAdeslas) {
    const url = el.url;

    if (window.location.href.indexOf("segurcaixaadeslas") > -1) {
      if (window.location.href.indexOf(url) > -1) {
        dataLayerAdeslas.categoriaSeguro = el.categoria_seguro;
        dataLayerAdeslas.tipoSeguro = el.tipo_seguro;
        dataLayerAdeslas.seccionWeb = el.seccion_web;
        break;
      }
    }
  }
}

// Establecer declarativas con las cookies _fbc y _fbp
function getCookieFacebook() {
  let cookies = document.cookie.split(";");
  var cookiesFA = {
    _fbp: "_fbp=",
    _fbc: "_fbc=",
  };

  for (let key in cookiesFA) {
    let nameComplete = cookiesFA[key];
    for (let i = 0; i < cookies.length; i++) {
      let cookie = cookies[i].trim();
      if (cookie.indexOf(nameComplete) === 0) {
        cookiesFA[key] = decodeURIComponent(
          cookie.substring(nameComplete.length, cookie.length)
        );
        break; // Salir del bucle for cuando se encuentra una cookie correspondiente
      } else {
        cookiesFA[key] = null;
      }
    }
  }
  return cookiesFA;
}

function watchCookie() {
  let timeoutId = null; // ID del timeout para poder cancelarlo más tarde
  const startTime = Date.now(); // Tiempo de inicio para calcular el tiempo transcurrido
  const maxDuration = 3 * 60 * 1000; // Tiempo para parar el observador
  const checkCookieChange = () => {
    // Verifica si han pasado X minutos desde que comenzó la observación
    if (Date.now() - startTime >= maxDuration) {
      return; // Detiene la función si han pasado 5 minutos
    }
    timeoutId = setTimeout(() => {
      var currentCookieValue = getCookieFacebook();
      if (
        Object.keys(currentCookieValue).some(
          (key) => currentCookieValue[key] !== null
        )
      ) {
        let cookie_fbp =
          currentCookieValue._fbp != "" && currentCookieValue._fbp != null
            ? currentCookieValue._fbp
            : null;
        let cookie_fbc =
          currentCookieValue._fbc != "" && currentCookieValue._fbc != null
            ? currentCookieValue._fbc
            : null;
        dataLayerAdeslas.cookie_fbp = cookie_fbp;
        dataLayerAdeslas.cookie_fbc = cookie_fbc;
        if (
          typeof DFI != "undefined" &&
          typeof DFI.labelsVarRingPool != "undefined"
        ) {
          window.DFI.labelsVarRingPool.EDeclaratives.cookie_fbp = cookie_fbp;
          window.DFI.labelsVarRingPool.EDeclaratives.cookie_fbc = cookie_fbc;
        }
      } else {
        checkCookieChange();
      }
    }, 800); // Intervalo de sondeo
  };

  checkCookieChange();

  // Establecer un límite de tiempo para detener la observación después de 5 minutos
  setTimeout(() => {
    clearTimeout(timeoutId);
    console.log(
      `Se ha detenido la observación de las cookies FA después de 5 minutos.`
    );
  }, maxDuration);
}

watchCookie();
//Seteo de setServiceRingpool para regla de llamada
const url = new URL(window.location.href);

const fechaActual = new Date();
const diaDeLaSemana = fechaActual.getDay();

if (diaDeLaSemana >= 1 && diaDeLaSemana <= 5) {
  dataLayerAdeslas.setServiceRingpool = "L-V";
} else {
  dataLayerAdeslas.setServiceRingpool = "S-D";
}

// Añadir elementos para evitar consumo de ring pool.
const avoidRingPoolDefault = document.createElement("div");
avoidRingPoolDefault.innerHTML =
  '<div class="drp-phone wal-drp-phone html-drp-phone" style="display:none"></div>';
const bodyEnd = document.getElementsByTagName("body")[0];
bodyEnd.appendChild(avoidRingPoolDefault);

if (DFI_client.alreadyLoaded != true) {
  DFI_client.alreadyLoaded = true;

  if (window.location.href.indexOf("area-clientes") > -1) {
    window.idTagDelio =
      "29842f94d414949bf95fb2e6109142cfef1fb2a78114c2c536a36bf5a65b953a0b316317a618ff359b9637ebc47c86fb70a667226cd3b039d6e93dc5bf8112f8577f52f3793452150f1611ae87eaa2dfb11e9c18dcc75fdaf8193a66486a8e362280e919e66a5b9da4cf6996bd5bfa39";
  } else {
    window.idTagDelio =
      "29842f94d414949bf95fb2e6109142cfef1fb2a78114c2c536a36bf5a65b953aae636090917c003002e97758b0e81efa029559b1bae7df3a45536d5c36fc2f567a0ca4a14c080dbe7f601cea7019a16610968c55948828aa9c72bebdbb63b34980fa3d1e48c3fad33ab38aa009fca5ab";
  }
  var script = document.createElement("script");
  script.type = "text/javascript";
  script.src = "https://t.womtp.com/slider/c/delio-lm/dfi/init.js";
  var head = document.getElementsByTagName("head")[0];
  head.appendChild(script);
}

// ------------------------------------------
// MODAL IVR ADESLAS
// ------------------------------------------
var watingLoadModal = setInterval(function () {
  flgExecuted = false;
  if (
    (window.location.href.lastIndexOf("https://www.segurcaixaadeslas.es") ==
      0 ||
      window.location.href.lastIndexOf("https://segurcaixaadeslas.es") == 0) &&
    typeof DFI === "object" &&
    typeof DFI.labels === "object" &&
    typeof DFI.labels.EVisits === "object" &&
    !flgExecuted
  ) {
    flgExecuted = true;
    DFI.labels.EVisits.v_var_2 = "segurcaixaadeslas";
    DFI.labels.EVisitsDef = [
      {
        id: 1,
        value: "ring pool",
      },
    ];
    const i = 0;
    for (const property in DFI.labels.EVisits) {
      const indice = property.replace("v_var_", "");
      DFI.labels.EVisitsDef.push({
        id: +indice,
        value: DFI.labels.EVisits[property],
      });
      window[property] = DFI.labels.EVisits[property];
    }
    if (typeof statusDFI.limitUpdatesRingPoolVars !== "number") {
      statusDFI.limitUpdatesRingPoolVars = 0;
    }
    if (
      statusDFI.initRingpoolCompleted &&
      statusDFI.limitUpdatesRingPoolVars < 5 &&
      typeof window.DFI.labelsVarRingPool !== "undefined"
    ) {
      window.DFI.labelsVarRingPool.Evisit = DFI.labels.EVisitsDef;
      DAL.Ajax({
        type: "jsonp",
        url:
          DFI.global.sendRingPoolLabels +
          "idTag=" +
          window.DFI.DFI_configuration.idTagDelioClient +
          "&idvisitor=" +
          Piwik.getAsyncTracker().getVisitorId() +
          "&labels=" +
          JSON.stringify(window.DFI.labelsVarRingPool) +
          "&idServ=" +
          window.DFI.servicioActivo1.serviceIdRingPool,
      })
        .done(function (responseRingPoolLabels) {
          DFI.consoleLogDelio(
            "sendRingPoolLabels OK: " + responseRingPoolLabels
          );
          return true;
        })
        .fail(function (responseRingPoolLabels) {
          DFI.consoleLogDelio(
            "sendRingPoolLabels NOK: " + responseRingPoolLabels
          );
        });
      statusDFI.limitUpdatesRingPoolVars++;
    }
  }
  const dsaButton = document.querySelector(".dModalForm");
  const atnContainer = document.querySelector("#atnCliente-modal");
  if (dsaButton && atnContainer) {
    clearInterval(watingLoadModal);
    console.log("configModalAdeslas");
    configModalAdeslas();
  }
}, 600);

function configModalAdeslas() {
  window.ADESLASMODAL = {
    addLead: {
      container: document.querySelector("#addLead-modal"),
      comeback: document.querySelector("#addLead-modal-volver"),
      comebackYaCliente: document.querySelector(
        ".yaCliente-modal #addLead-modal-volver"
      ),
    },
    esCliente: {
      container: document.querySelector("#esCliente-modal"),
      botonSi: document.querySelector("#esCliente-buttons_si"),
      botonNo: document.querySelector("#esCliente-buttons_no"),
      textSi: document.querySelector("#esCliente-text_si"),
      textNo: document.querySelector("#esCliente-text_no"),
    },
    gestion: {
      container: document.querySelector("#gestion-modal"),
      botonGestion: document.querySelector("#gestion-buttons_gestionar"),
      botonContrato: document.querySelector("#gestion-buttons_contratar"),
      comeback: document.querySelector("#gestion-modal-volver"),
    },
    atnCliente: {
      container: document.querySelector("#atnCliente-modal"),
      botonPhone: document.querySelector("#tnCliente-buttons_phone"),
      comeback: document.querySelector("#gestion-modal-volver"),
    },
  };

  // FUNCIONES
  ADESLASMODAL.ocultar = function (element) {
    element.style.display = "none";
  };

  ADESLASMODAL.mostrar = function (element) {
    element.style.display = "block";
  };

  const esClienteButton = document.querySelector(
    "label[for=ctl00_SPWebPartManager1_g_4413f124_985f_4a9c_8fd0_9aa1c90c93b8_ctl00_check_yes]"
  );
  if (esClienteButton) {
    esClienteButton.addEventListener("click", function () {
      setCookie("yaCliente", "yaCliente", 30);
    });
  }

  if (typeof DFI.getCookie("yaCLiente") !== "undefined") {
    const dsaButton = document.querySelector(".dModalForm");
    dataLayerAdeslas.yaCliente = "Cliente";
    DFI.setDataLayer();
    DFI.setDeclaratives();
    dsaButton.addEventListener("click", function () {
      if (window.gestionVisto == true) {
      } else {
        ADESLASMODAL.ocultar(ADESLASMODAL.esCliente.container);
        ADESLASMODAL.mostrar(ADESLASMODAL.gestion.container);
      }
    });
  }

  // EVENTOS
  // esCliente
  var esClienteReady = setInterval(function () {
    if (
      ADESLASMODAL.esCliente.container &&
      typeof ADESLASMODAL.esCliente.container === "object"
    ) {
      clearInterval(esClienteReady);

      // esCliente Si
      ADESLASMODAL.esCliente.botonSi.addEventListener("mouseover", function () {
        ADESLASMODAL.esCliente.textSi.classList.add("active");
      });
      ADESLASMODAL.esCliente.botonSi.addEventListener("mouseout", function () {
        ADESLASMODAL.esCliente.textSi.classList.remove("active");
      });

      console.log(ADESLASMODAL.esCliente.botonSi);

      ADESLASMODAL.esCliente.botonSi.addEventListener("click", function () {
        ADESLASMODAL.ocultar(ADESLASMODAL.esCliente.container);
        ADESLASMODAL.mostrar(ADESLASMODAL.gestion.container);
        dataLayerAdeslas.yaCliente = "Cliente";
        DFI.setDataLayer();
        DFI.setDeclaratives();
      });

      // esCliente No
      ADESLASMODAL.esCliente.botonNo.addEventListener("mouseover", function () {
        ADESLASMODAL.esCliente.textNo.classList.add("active");
      });
      ADESLASMODAL.esCliente.botonNo.addEventListener("mouseout", function () {
        ADESLASMODAL.esCliente.textNo.classList.remove("active");
      });

      console.log(ADESLASMODAL.esCliente.botonNo);

      ADESLASMODAL.esCliente.botonNo.addEventListener("click", function () {
        ADESLASMODAL.ocultar(ADESLASMODAL.esCliente.container);
        ADESLASMODAL.mostrar(ADESLASMODAL.addLead.container);
        dataLayerAdeslas.yaCliente = "No cliente";
        DFI.setDataLayer();
        DFI.setDeclaratives();
      });
    }
  }, 600);

  // gestion
  if (ADESLASMODAL.gestion.container) {
    ADESLASMODAL.gestion.botonGestion.addEventListener("click", function () {
      ADESLASMODAL.ocultar(ADESLASMODAL.gestion.container);
      ADESLASMODAL.mostrar(ADESLASMODAL.atnCliente.container);
      window.gestionVisto = true;
    });
    ADESLASMODAL.gestion.botonContrato.addEventListener("click", function () {
      ADESLASMODAL.ocultar(ADESLASMODAL.gestion.container);
      ADESLASMODAL.mostrar(ADESLASMODAL.addLead.container);
      dataLayerAdeslas.yaCliente = "Cliente";
      if (dataLayerAdeslas.yaCliente == "Cliente") {
        ADESLASMODAL.addLead.container.classList.add("yaCliente-modal");
      }
    });
    ADESLASMODAL.gestion.comeback.addEventListener("click", function () {
      ADESLASMODAL.ocultar(ADESLASMODAL.gestion.container);
      ADESLASMODAL.mostrar(ADESLASMODAL.esCliente.container);
    });
  }
  // addLead
  if (ADESLASMODAL.addLead.container) {
    ADESLASMODAL.addLead.comeback.addEventListener("click", function () {
      if (
        ADESLASMODAL.addLead.container.classList.contains("yaCliente-modal")
      ) {
        ADESLASMODAL.addLead.container.classList.remove("yaCliente-modal");
        ADESLASMODAL.ocultar(ADESLASMODAL.addLead.container);
        ADESLASMODAL.mostrar(ADESLASMODAL.gestion.container);
      } else {
        ADESLASMODAL.ocultar(ADESLASMODAL.addLead.container);
        ADESLASMODAL.mostrar(ADESLASMODAL.esCliente.container);
      }
    });
  }
}

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  const expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getUrlVarSegurcaixa(variable, url) {
  const href = url || window.location.search;
  let i, pair;
  const query = href.split("?")[1];
  const vars = query ? query.split("&") : [];

  for (i = 0; i < vars.length; i++) {
    pair = vars[i].split("=");

    if (pair[0] == variable && pair[1] !== "") return pair[1];
  }

  return "";
}

var mobileDsaFix = setInterval(function () {
  try {
    const maxwidth = document.documentElement.clientWidth;
    const dsaMobile = document.querySelector("#dsa-newId");
    const footerItemAdeslas = document.querySelector(
      ".sc-footer__ctn-bottom--mobile"
    );
    if (maxwidth <= "640" && dsaMobile && footerItemAdeslas) {
      clearInterval(mobileDsaFix);
      footerItemAdeslas.style.paddingBottom = "120px";
      dsaMobile.style.display = "none !important";
    }
  } catch (error) {}
}, 600);

/* Codigo para eliminar el btn en version mobiletodo en todo el dominio :DLIO-14843 */
const removeBtn = setInterval(() => {
  const btnRemove = document.querySelector("#dsa-newId");
  const widthWindow = document.documentElement.clientWidth;
  if (
    btnRemove &&
    widthWindow <= "500" &&
    window.location.host == "www.segurcaixaadeslas.es"
  ) {
    clearInterval(removeBtn);
    btnRemove.style.display = "none";
  }
}, 30);

if (
  window.location.href.indexOf("segurcaixaadeslas.es/tarificador/") > -1 ||
  window.location.href.indexOf("segurcaixaadeslas.es/ca/tarificador/") > -1 ||
  window.location.href.indexOf("segurcaixaadeslas.es/en/tarificador/") > -1
) {
  // interferimos ringpool en tarificador
  var waitDRP = setInterval(function () {
    try {
      const drps = document.querySelectorAll("a.wal-drp-phone");
      if (drps.length > 0) {
        clearInterval(waitDRP);
        drps.forEach(function (el) {
          el.classList.add("html-drp-phone");
        });
      }
    } catch (error) {}
  }, 600);

  // interferimos Modal de D1C en tarificador
  var waitModal = setInterval(function () {
    try {
      const modalDForm = document.querySelectorAll(".dModalForm");
      if (modalDForm.length > 0) {
        clearInterval(waitModal);
        modalDForm.forEach(function (el) {
          el.addEventListener("click", DFI.ModalView.open, false);
        });
      }
    } catch (error) {}
  }, 600);
}

// Listener actualizar página.
DFI_client.waitModalLoadedFlag = true;
DFI_client.waitModalLoadedFlagEventsTasks = true;
window.addEventListener("storage", function (event) {
  if (
    window.localStorage.getItem("ModalOn") == "true" ||
    dataLayerAdeslas.ModalOn == " true" ||
    dataLayerAdeslas.ModalOn ||
    typeof dataLayerAdeslas.ModalOn === "undefined"
  ) {
    window.dataLayerAdeslas.activeModalIdDoubleEvent =
      window.dataLayerAdeslas.activeModalId;
  }

  if (
    window.localStorage.getItem("DsaOn") == "true" ||
    (typeof dataLayerAdeslas.DsaOn !== "undefined" &&
      (dataLayerAdeslas.DsaOn == " true" || dataLayerAdeslas.DsaOn))
  ) {
    window.dataLayerAdeslas.activeDsaIdDoubleEvent =
      window.dataLayerAdeslas.activeDsaId;
  }

  // Verificamos que todas las dependecias están cargadas.
  // window.DFI.resultShowRules.modalId

  if (DFI_client.waitModalLoadedFlagEventsTasks) {
    DFI_client.waitModalLoadedFlagEventsTasks = false;
    if (DFI_client.waitModalLoadedFlag) {
      DFI_client.waitModalLoaded = setInterval(function () {
        if (
          typeof window.DFI === "object" &&
          typeof window.DFI.resultShowRules === "object" &&
          DFI_client.waitModalLoadedFlag != false &&
          statusDFI.gatewaysLoaded === true
        ) {
          if (statusDFI.initModalView != true) {
            DFI.initModalView();
            statusDFI.addDelioClientToForms = false;
            DFI.addDelioClientToForms(); // - 26/04
            DCL.set.forms(); //- 26/04
          }
          DFI_client.waitModalLoadedFlag = false;
          clearInterval(DFI_client.waitModalLoadedFlag);
          DFI_client.DsaModalManagement();
          DFI_client.waitModalLoadedFlagEventsTasks = true;
        }
      }, 600);
    } else {
      DFI_client.DsaModalManagement();
      DFI_client.waitModalLoadedFlagEventsTasks = true;
    }
  }
});

DFI_client.DsaModalManagement = function () {
  if (
    (dataLayerAdeslas.popUpTipo === "tarificadorWeb" ||
      typeof dataLayerAdeslas.popUpTelefono !== "undefined") &&
    dataLayerAdeslas.flagWalmeric != true
  ) {
    dataLayerAdeslas.flagWalmeric === true;
    if (
      typeof Piwik === "object" &&
      typeof Piwik.getAsyncTracker() === "object" &&
      typeof Piwik.getAsyncTracker().getVisitorId() === "string"
    ) {
      // var btnsModalForm = document.querySelectorAll('.dModalForm');

      // for (var i = 0; i < btnsModalForm.length; i++) {
      //     btnsModalForm[i].addEventListener('click', DFI.ModalView.open, false);
      // }
      window.localStorage.removeItem("updateProperties");
      DFI.setDataLayer();
      statusDFI.setDataLayer = true;
      DFI.setDeclaratives();
      statusDFI.setDeclaratives = true;
      DFI.updateFormAside(document.querySelector(".wg-form"));
      DFI.AdeslascheckRingPoolCounter = 0;
      DFI.AdeslascheckRingPool = setInterval(function () {
        if (statusDFI.initRingpoolCompleted && typeof DRP === "function") {
          clearInterval(DFI.AdeslascheckRingPool);
          DFI.refreshRingpool();
        }
        if (DFI.AdeslascheckRingPoolCounter > 5) {
          clearInterval(DFI.AdeslascheckRingPool);
        }

        DFI.AdeslascheckRingPoolCounter++;
      }, 500);
    }
    dataLayerAdeslas.flagWalmeric === false;
    if (typeof DFI_client.lastPopUpTelefonoAddLead !== "number") {
      DFI_client.lastPopUpTelefonoAddLead = Date.now() - 60001;
    }
    if (
      typeof dataLayerAdeslas.popUpTelefono !== "undefined" &&
      dataLayerAdeslas.popUpTelefono != null &&
      Math.max(
        Math.floor(
          Math.log10(Math.abs(parseInt(dataLayerAdeslas.popUpTelefono)))
        ),
        0
      ) +
        1 >
        8 &&
      Date.now() - DFI_client.lastPopUpTelefonoAddLead > 60000
    ) {
      DFI_client.lastPopUpTelefonoAddLead = Date.now();
      dataLayerAdeslas.phone = dataLayerAdeslas.popUpTelefono;
      walmericJSONToSend = {};

      if (
        typeof DFI === "object" &&
        typeof DFI.labels === "object" &&
        typeof DFI.labels.EDeclaratives === "object"
      ) {
        walmericJSONToSend = dataLayerAdeslas;
        DFI.addLead(walmericJSONToSend, function () {
          // Call back
        });
      }
    }
  }

  window.DFI.DFI_configuration.modals.forEach((element, index) => {
    if (
      parseInt(element.id) == window.dataLayerAdeslas.activeModalIdDoubleEvent
    ) {
      console.log(element.name);
      console.log(index);
      window.dataLayerAdeslas.activeModalIndex = index;
      if (typeof DFI != "undefined") {
        DFI.refreshRingpool();
      }
    }
  });

  if (
    window.localStorage.getItem("DsaOn") == "true" ||
    (typeof dataLayerAdeslas.DsaOn !== "undefined" &&
      (dataLayerAdeslas.DsaOn == " true" || dataLayerAdeslas.DsaOn))
  ) {
    dataLayerAdeslas.DsaOn = false;
    window.localStorage.setItem("DsaOn", "false");
    if (window.dataLayerAdeslas.activeDsaIdDoubleEvent > -1) {
      if (
        window.DFI.resultShowRules.modalId > 0 &&
        typeof window.dataLayerAdeslas.activeModalIndex !== "undefined"
      ) {
        window.DFI.resultShowRules.modalId =
          window.dataLayerAdeslas.activeModalIdDoubleEvent;
        window.DFI.resultShowRules.modalIndex =
          window.dataLayerAdeslas.activeModalIndex;
        DFI.initModalView();
        statusDFI.addDelioClientToForms = false;
        DFI.addDelioClientToForms(); // - 26/04
        if (
          typeof DCL === "object" &&
          typeof DCL.set === "object" &&
          typeof DCL.set.forms === "function"
        ) {
          DCL.set.forms(); //- 26/04
        }
      }

      window.DFI.resultShowRules.dsaId =
        window.dataLayerAdeslas.activeDsaIdDoubleEvent;
      const dsaTemplate =
        window.DFI.DFI_configuration.DSAs[window.DFI.resultShowRules.dsaId - 1]
          .config.dsaHTML;
      if (
        window.DFI.DFI_configuration.DSAs[window.DFI.resultShowRules.dsaId - 1]
          .config.dsaStyles !== undefined &&
        window.DFI.DFI_configuration.DSAs[window.DFI.resultShowRules.dsaId - 1]
          .config.dsaStyles.length > 0
      ) {
        DAL.Ajax({
          type: "style",
          url: window.DFI.DFI_configuration.DSAs[
            window.DFI.resultShowRules.dsaId - 1
          ].config.dsaStyles,
        });
      }
      DFI.personalizedDSA(
        dsaTemplate,
        "82%",
        "400px",
        0.2,
        true,
        "walmeric_boton_c2c"
      );
    }
  }

  if (
    window.localStorage.getItem("ModalOn") == "true" ||
    dataLayerAdeslas.ModalOn == " true" ||
    dataLayerAdeslas.ModalOn ||
    typeof dataLayerAdeslas.ModalOn === "undefined"
  ) {
    dataLayerAdeslas.ModalOn = false;
    window.localStorage.setItem("ModalOn", "false");
    if (window.DFI.resultShowRules.modalId > 0) {
      window.DFI.resultShowRules.modalId =
        window.dataLayerAdeslas.activeModalIdDoubleEvent;
      window.DFI.resultShowRules.modalIndex =
        window.dataLayerAdeslas.activeModalIndex;
      DFI.setDataLayer();
      statusDFI.setDataLayer = true;
      DFI.setDeclaratives();
      statusDFI.setDeclaratives = true;
      DFI.initModalView();
      statusDFI.addDelioClientToForms = false;
      DFI.addDelioClientToForms(); // - 26/04
      DCL.set.forms(); // - 26/04
      if (statusDFI.initRingpoolCompleted && typeof DRP === "function") {
        DFI.refreshRingpool();
      }
      //ESTO HACE QUE CARGUE LA MODAL 2 : NO DESCOMENTAR HACE QUE FALLE EL CALLME REVISAR CON ISABEL
      //DFI.initModalView();
      // DFI.ModalView.open();
    }
  }
};

DFI_client.AdeslascheckRingPoolCounterTarificador = 0;
DFI_client.AdeslascheckRingPoolCounterTarificadorInterval = 500;
DFI_client.AdeslascheckRingPoolTarificador = setInterval(function () {
  if (
    window.location.pathname === "/tarificador/4978" &&
    typeof statusDFI === "object" &&
    typeof statusDFI.initRingpoolCompleted !== "undefined" &&
    typeof DRP === "function" &&
    document.querySelectorAll('[role="progressbar"]').length == 0
  ) {
    clearInterval(DFI_client.AdeslascheckRingPoolTarificador);
    if (DFI_client.AdeslascheckRingPoolCounterTarificadorInterval == 500) {
      DFI.setDataLayer();
      statusDFI.setDataLayer = true;
      DFI.setDeclaratives();
      statusDFI.setDeclaratives = true;
      DFI.refreshRingpool();
      DFI_client.AdeslascheckRingPoolCounterTarificadorInterval = 50000000000000;
    }

    if (DFI_client.AdeslascheckRingPoolCounterTarificador > 5) {
      clearInterval(DFI_client.AdeslascheckRingPoolTarificador);
    }

    DFI_client.AdeslascheckRingPoolCounterTarificador++;
  }
}, DFI_client.AdeslascheckRingPoolCounterTarificadorInterval);

DFI_client.intervalCheckModalButtonCounter = 500;
DFI_client.intervalCheckModalButton = setInterval(() => {
  if (document.querySelector("button.dModalForm")) {
    clearInterval(DFI_client.intervalCheckModalButton);
    document.querySelectorAll("button.dModalForm").forEach((button) => {
      button.addEventListener("click", () => {
        const telRingpool = DFI.telefonoRingPoolActivo
          ? DFI.telefonoRingPoolActivo
          : "919018200";
        const telRingpoolText = DFI.telefonoRingPoolActivo
          ? DFI.telefonoRingPoolActivo.replace(
              /^(\d{2})(\d{3})(\d{2})(\d{2})$/,
              "$1 $2 $3 $4"
            )
          : "91 901 82 00";
        document
          .querySelectorAll(".drp-phone.wal-drp-phone.html-drp-phone")
          .forEach((phone) => {
            phone.href = `tel:${telRingpool}`;
            phone.innerText = `${telRingpoolText}`;
          });
      });
    });
  }
}, DFI_client.intervalCheckModalButtonCounter);

DFI_client.changeFormat = function (minutos) {
  const tzoffset = new Date().getTimezoneOffset() * 60000; // offset in milliseconds
  const fecha = new Date();
  const fechaModificada = Date.now() + parseInt(minutos) * 60000;

  const localISOTime = new Date(fechaModificada - tzoffset)
    .toISOString()
    .slice(0, -1);
  return localISOTime;
};

DFI_client.getQueryVariable = function (variable, url) {
  const href = url || window.location.search;
  let i, pair;
  const query = href.split("?")[1];
  const vars = query ? query.split("&") : [];

  for (i = 0; i < vars.length; i++) {
    pair = vars[i].split("=");

    if (pair[0] == variable && pair[1] !== "") return pair[1];
  }

  return false;
};

DFI_client.intervalRadioButtonModal = () => {
  if (document.querySelector("input[name=radioCallMe]")) {
    clearInterval(DFI_client.intervalRadioButtonModal);
    const cmn = document.querySelector("#cmnRadio");
    const cmb = document.querySelector("#cmbRadio");

    const radio = document.getElementsByName("radioCallMe");
    radio.forEach((radio) => {
      radio.classList.remove("wg-input");
    });

    if (cmb && cmn) {
      cmn.addEventListener("click", (e) => {
        if (e.target.value == "ahora") {
          document
            .querySelector('input[name="cmNow"]')
            .setAttribute("value", "Si");
          document
            .querySelector('input[name="cmBack"]')
            .setAttribute("value", "No");
        }
      });

      cmb.addEventListener("click", (e2) => {
        if (e2.target.value == "luego") {
          if (document.querySelector('input[name="cmBOfi"]')) {
            const minutesCmBack = 5;
            const sheduleCmBack = DFI_client.changeFormat(minutesCmBack);
            document
              .querySelector('input[name="cmNow"]')
              .setAttribute("value", "No");
            document
              .querySelector('input[name="cmBack"]')
              .setAttribute("value", "Si_oficina");
            document
              .querySelector('input[name="cmBOfi"]')
              .setAttribute("value", sheduleCmBack);
            setInterval(() => {
              const sheduleCmBackUpdated =
                DFI_client.changeFormat(minutesCmBack);
              document
                .querySelector('input[name="cmBOfi"]')
                .setAttribute("value", sheduleCmBackUpdated);
            }, 30000);
          } else {
            document
              .querySelector('input[name="cmBack"]')
              .setAttribute("value", "Si");
            document
              .querySelector('input[name="cmNow"]')
              .setAttribute("value", "No");
          }
        }
      });
    }
  }
};

/* WCS-24978 Hablar con TI Walmeric */
DFI_client.removeRingpool = setInterval(() => {
  const rpMutualidades = document.querySelector(".sc-modal__content_moreinfo");
  if (
    window.location.pathname == "/mutualidades/adeslas-extra-eleccion" &&
    rpMutualidades
  ) {
    clearInterval(DFI_client.intervalRadioButtonModal);

    const elem = document.querySelectorAll(
      "#ctl00_SPWebPartManager1_g_b3aa847d_3178_4ee2_a8b4_200ef4a86cb2_ctl00_txtTelef"
    )[1];
    if (elem) {
      elem.classList.remove("drp-phone");
      elem.classList.remove("wal-drp-phone");
      elem.classList.remove("html-drp-phone");
      elem.href = "tel:919034457";
      elem.innerHTML = "91 903 44 57";
    }
  }
}, 200);

/* WCS-25308 Hablar con TI Walmeric */

DFI_client.removeRingpoolCat = setInterval(() => {
  const rpMutualidadesCat = document.querySelector(
    ".sc-modal__content_moreinfo"
  );
  if (
    window.location.pathname == "/ca/mutualitats/adeslas-extra-eleccio" &&
    rpMutualidadesCat
  ) {
    clearInterval(DFI_client.intervalRadioButtonModal);

    const elem = document.querySelectorAll(
      "#ctl00_SPWebPartManager1_g_b3aa847d_3178_4ee2_a8b4_200ef4a86cb2_ctl00_txtTelef"
    )[1];
    if (elem) {
      elem.classList.remove("drp-phone");
      elem.classList.remove("wal-drp-phone");
      elem.classList.remove("html-drp-phone");
      elem.href = "tel:919034457";
      elem.innerHTML = "91 903 44 57";
    }
  }
}, 200);

DFI_client.intervalFakePostalValidationCounter = 100;
DFI_client.intervalFakePostalValidation = setInterval(() => {
  if (document.querySelector(".walmericFakeSubmit")) {
    clearInterval(DFI_client.intervalFakePostalValidation);
    const walmericFakeSubmit = document.querySelector(".walmericFakeSubmit");
    const walmericSubmit = document.querySelector(".walmericSubmit");
    const postalCode = document.querySelector(".postalCode");
    const wgErrorPostalCode = document.querySelector(".wg-error-postalCode");
    const regex = /^[0-9]{5}$/;

    walmericFakeSubmit.addEventListener("click", () => walmericSubmit.click());

    postalCode.addEventListener("blur", (event) => {
      if (regex.test(event.target.value)) {
        wgErrorPostalCode.style.display = "none";
      } else {
        wgErrorPostalCode.style.display = "block";
      }
    });
  }
}, DFI_client.intervalFakePostalValidationCounter);

DFI_client.Modal2On = function (Modalid) {
  window.DFI.DFI_configuration.modals.forEach((element, index) => {
    if (parseInt(element.id) == Modalid) {
      console.log(element.name);
      console.log(index);
      DFI_client.languageModalIndex = index;
      if (typeof DFI != "undefined") {
        DFI.refreshRingpool();
      }
    }
  });

  window.DFI.resultShowRules.modalId = Modalid;
  window.DFI.resultShowRules.modalIndex = DFI_client.languageModalIndex;
  DFI.setDataLayer();
  statusDFI.setDataLayer = true;
  DFI.setDeclaratives();
  statusDFI.setDeclaratives = true;
  DFI.initModalView();
  statusDFI.addDelioClientToForms = false;
  DFI.addDelioClientToForms(); //- 26/04
  DCL.set.forms(); //- 26/04
  if (statusDFI.initRingpoolCompleted && typeof DRP === "function") {
    DFI.refreshRingpool();
  }
};

const exclude_URLs = [
  "https://www.segurcaixaadeslas.es/particulares/encuentra-tu-seguro",
  "https://www.segurcaixaadeslas.es/particulares/calcula-tu-seguro",
  "https://www.segurcaixaadeslas.es/particulares/contrata-tu-seguro",
  "https://www.segurcaixaadeslas.es/particulares/promocion-salud",
];

DFI_client.AdeslascheckRingPoolCounterseguros_medicos = 0;
DFI_client.AdeslascheckRingPoolCounterseguros_medicosInterval = 500;
DFI_client.AdeslascheckRingPoolseguros_medicos = setInterval(function () {
  if (
    window.location.host === "www.segurcaixaadeslas.es" &&
    typeof statusDFI === "object" &&
    typeof statusDFI.initRingpoolCompleted !== "undefined" &&
    typeof DRP === "function" &&
    dataLayerAdeslas.DsaOn == false
  ) {
    clearInterval(DFI_client.AdeslascheckRingPoolseguros_medicos);
    if (DFI_client.AdeslascheckRingPoolCounterseguros_medicosInterval == 500) {
      const url = window.location.href;

      if (url.includes("https://www.segurcaixaadeslas.es/ca")) {
        DFI_client.Modal2On(17);
        window.idModal = 17;
      } else if (url.includes("https://www.segurcaixaadeslas.es/en")) {
        DFI_client.Modal2On(18);
        window.idModal = 18;
      } else if (
        url.includes(
          "https://www.segurcaixaadeslas.es/mutualidades/adeslas-extra-eleccion"
        )
      ) {
        DFI_client.Modal2On(19);
        window.idModal = 19;
      } else if (
        url.includes(
          "https://www.segurcaixaadeslas.es/ca/mutualitats/adeslas-extra-eleccio"
        )
      ) {
        DFI_client.Modal2On(20);
        window.idModal = 20;
      } else if (exclude_URLs.includes(url)) {
        DFI_client.Modal2On(16);
        window.idModal = 16;
      } else {
        DFI_client.Modal2On(14);
        window.idModal = 14;
      }

      DFI_client.intervalRadioButtonModal();

      DFI_client.AdeslascheckRingPoolCounterseguros_medicosInterval = 50000000000000;
    }

    if (DFI_client.AdeslascheckRingPoolCounterseguros_medicos > 5) {
      clearInterval(DFI_client.AdeslascheckRingPoolseguros_medicos);
    }

    DFI_client.AdeslascheckRingPoolCounterseguros_medicos++;
  }
}, DFI_client.AdeslascheckRingPoolCounterseguros_medicosInterval);

DFI_client.cartModal = function (language) {
  /* CONFIGURA LA MODAL DEL TARIFICADOR */
  DFI_client.languageModalId = 4;
  DFI_client.languageModalIndex = 11;

  if (language === "EN") {
    DFI_client.languageModalId = 13;
    DFI_client.languageModalIndex = 4;
  }
  if (language === "CAT") {
    DFI_client.languageModalId = 7;
    DFI_client.languageModalIndex = 14;
  }

  window.DFI.DFI_configuration.modals.forEach((element, index) => {
    if (parseInt(element.id) == DFI_client.languageModalId) {
      console.log(element.name);
      console.log(index);
      DFI_client.languageModalIndex = index;
      if (typeof DFI != "undefined") {
        DFI.refreshRingpool();
      }
    }
  });

  window.DFI.resultShowRules.modalId = DFI_client.languageModalId;
  window.DFI.resultShowRules.modalIndex = DFI_client.languageModalIndex;
  DFI.setDataLayer();
  statusDFI.setDataLayer = true;
  DFI.setDeclaratives();
  statusDFI.setDeclaratives = true;
  DFI.initModalView();
  statusDFI.addDelioClientToForms = false;
  DFI.addDelioClientToForms(); // - 26/04
  DCL.set.forms(); //- 26/04
  if (statusDFI.initRingpoolCompleted && typeof DRP === "function") {
    DFI.refreshRingpool();
  }
  DFI.ModalView.open();
};

DFI_client.interfModalWhenLoadCounter = 0;
DFI_client.interfModalWhenLoad = setInterval(() => {
  if (
    typeof dataLayerAdeslas.activeModalId !== "undefined" &&
    dataLayerAdeslas.activeModalId == 14 &&
    document.querySelector("input[name=radioCallMe]")
  ) {
    clearInterval(DFI_client.interfModalWhenLoad);

    DFI_client.intervalRadioButtonModal();
  }

  if (DFI_client.interfModalWhenLoadCounter > 50) {
    clearInterval(DFI_client.interfModalWhenLoad);
  }

  DFI_client.interfModalWhenLoadCounter++;
}, 500);
